// import { useState } from 'react';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import { BaseUrl } from '../../../Actions/Base';

// const InstructorCards = ({ instructors, CoursePackage }) => {
//   const [inVehicleIndex, setInVehicleIndex] = useState(0);
//   const [inClassIndex, setInClassIndex] = useState(0);
//   const [onlineIndex, setOnlineIndex] = useState(0);

//   const {
//     DrivingHours,
//     InClassHours,
//     OnlineHours
//   } = CoursePackage;
  

//   const handleNext = (type) => {
//     if (type === 'vehicle') {
//       setInVehicleIndex((prev) => (prev + 1) % instructors.length);
//     } else if (type === 'class') {
//       setInClassIndex((prev) => (prev + 1) % instructors.length);
//     } else {
//       setOnlineIndex((prev) => (prev + 1) % instructors.length);
//     }
//   };

//   const handlePrev = (type) => {
//     if (type === 'vehicle') {
//       setInVehicleIndex((prev) => (prev - 1 + instructors.length) % instructors.length);
//     } else if (type === 'class') {
//       setInClassIndex((prev) => (prev - 1 + instructors.length) % instructors.length);
//     } else {
//       setOnlineIndex((prev) => (prev - 1 + instructors.length) % instructors.length);
//     }
//   };


//   const renderInstructorCard = (instructor, label, hours, type, color, borderColor) => (
//     <div className="flex justify-between w-[450px] 4xl:w-[30%] h-[105px] bg-[#FAFAFB] pl-[15px]">
//       <div className="flex gap-[10px] items-center">
//         <img
//           src={`${BaseUrl}/api/images/Instructors?url=${instructor?.Instructor?.ProfileImage}`}
//           alt="Instructor"
//           className="w-[66px] h-[66px] rounded-[9px]"
//         />
//         <p className="text-[16px] font-semibold text-[#696974] w-[130px]">
//           {instructor?.FirstName} {instructor?.LastName}
//         </p>
//         <div
//           onClick={() => handlePrev(type)}
//           className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630] cursor-pointer"
//         >
//           <ArrowBackIcon sx={{ color: 'white' }} />
//         </div>
//         <div
//           onClick={() => handleNext(type)}
//           className="w-[30px] h-[30px] rounded-full flex justify-center items-center bg-[#0AA630] cursor-pointer"
//         >
//           <ArrowForwardIcon sx={{ color: 'white' }} />
//         </div>
//       </div>

//       <div
//         className="bg-no-repeat p-[10px] flex flex-col gap-[10px] justify-center items-center"
//         // style={{ border: '1px solid #0AA630' }}
//         style={{ backgroundColor: `${color}`, border: `1px solid ${borderColor}` }}
//       >
//         <p className="text-[14px] text-[#696974] font-poppinssans text-center w-[80px]">
//           {label}
//         </p>
//         <p className="text-[16px] text-[#696974] font-semibold">{hours}</p>
//       </div>
//     </div>
//   );

//   return (
//     <div className="flex flex-wrap justify-center 4xl:justify-between items-center gap-[30px] w-full">
//       {renderInstructorCard(instructors[inVehicleIndex], 'In-Vehicle Classes', DrivingHours, 'vehicle', '#EBF8EE', '#0AA630')}
//       {renderInstructorCard(instructors[inClassIndex], 'In-Class Classes', InClassHours, 'class', '#FAFAFB', '#1F7BF4')}
//       {renderInstructorCard(instructors[onlineIndex], 'Online Classes', OnlineHours, 'online', '#FFEBEB', '#FC0000')}
//     </div>
//   );
// };

// export default InstructorCards;


import { useState, useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { BaseUrl } from '../../../Actions/Base';
import ScheduleConfirmationPopup from './ScheduleConfirmationPopup';

const InstructorCards = ({
  instructors,
  CoursePackage,
  setInstructorSelectedType,
  SelectInstructorCallback,
  instructorSelectedType,
  addClassEvents,
  setShowScheduleConfirmationPopup,
  showScheduleConfirmationPopup,
  setFinalClassesSchedule,
  setAddClassEvents,
  finalClassesSchedule,
  activeType,
  setActiveType,
  setFinalDrivingClassesSchedule,
  setFinalInClassClassesSchedule,
  setFinalOnlineClassesSchedule,
  isSeparateSchedule,
  finalDrivingClassesSchedule,
  finalInClassClassesSchedule,
  finalOnlineClassesSchedule,
  setAddClassError,
  setShowWeeklyAddClassPopup,
  setShowAddClassPopup,
  allInstructorsScheduledClasses,
  setShowDiscardSchedulePopup
}) => {
  // Index into the instructors[] array for each card type
  const [inVehicleIndex, setInVehicleIndex] = useState(0);
  const [inClassIndex, setInClassIndex] = useState(0);
  const [onlineIndex, setOnlineIndex] = useState(0);
  const [showAllLanguages, setShowAllLanguages] = useState({});
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
  const [sortedCourseInstructors, setSortedCourseInstructors] = useState([]);

  // Track which card type is currently “enabled” (null = none)
  const [selectedInstructorCardType, setSelectedInstructorCardType] = useState(null);

  // Pull hours from CoursePackage
  const { 
    DrivingHours  = 0, 
    InClassHours  = 0, 
    OnlineHours   = 0 
  } = CoursePackage || {};

  useEffect(() => {
    if (instructorSelectedType === "Driving") {
      SelectInstructorCallback("Driving", sortedCourseInstructors[inVehicleIndex]);
    }
  }, [inVehicleIndex]);  

  useEffect(() => {
    if (instructorSelectedType === "InClass") {
      SelectInstructorCallback("InClass", sortedCourseInstructors[inClassIndex]);
    }
  }, [inClassIndex]);
  
  useEffect(() => {
    if (instructorSelectedType === "Online") {
      SelectInstructorCallback("Online", sortedCourseInstructors[onlineIndex]);
    }
  }, [onlineIndex]);
  
  // Whenever we move Next/Prev, we’ll compute the new index,
  const handleNext = (type) => {
    if (type !== activeType) return;

    // ❌ Prevent switching if there's a draft schedule
    if (addClassEvents.length > 0) {
      setAddClassError("Please discard the current schedule before selecting a new instructor.");
      setTimeout(() => setAddClassError(''), 10000);
      return;
    }

    if (type === 'Driving') {
      const newIdx = (inVehicleIndex + 1) % sortedCourseInstructors.length;
      console.log("newIdx:",newIdx)
      setInVehicleIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Driving")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else if (type === 'InClass') {
      const newIdx = (inClassIndex + 1) % sortedCourseInstructors.length;
      setInClassIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("InClass")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else {
      const newIdx = (onlineIndex + 1) % sortedCourseInstructors.length;
      setOnlineIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Online")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    }
  };

  const handlePrev = (type) => {
    if (type !== activeType) return;

    // ❌ Prevent switching if there's a draft schedule
    if (addClassEvents.length > 0) {
      setAddClassError("Please discard the current schedule before selecting a new instructor.");
      setTimeout(() => setAddClassError(''), 10000);
      return;
    }

    if (type === 'Driving') {
      const newIdx = (inVehicleIndex - 1 + sortedCourseInstructors.length) % sortedCourseInstructors.length;
      console.log("newIdx:",newIdx)
      setInVehicleIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Driving")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else if (type === 'InClass') {
      const newIdx = (inClassIndex - 1 + sortedCourseInstructors.length) % sortedCourseInstructors.length;
      setInClassIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("InClass")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    } else {
      const newIdx = (onlineIndex - 1 + sortedCourseInstructors.length) % sortedCourseInstructors.length;
      setOnlineIndex(newIdx);
    //   SelectInstructorCallback(type, instructors[newIdx]);
      setInstructorSelectedType("Online")
      console.log("SelectInstructorCallback:",SelectInstructorCallback)
    }
  };

  // When you click the card, mark that card type as active and immediately select its current instructor
  const handleActivate = (type) => {

     // 🔄 If same card type is already active and editing is in progress, ignore click
    if (instructorSelectedType === type && addClassEvents.length > 0) {
      return;
    }

    if (instructorSelectedType) {
      if (addClassEvents.length > 0) {
        // Show a popup instead of proceeding
        setSelectedInstructorCardType(type)
        setShowScheduleConfirmationPopup(true); // or setShowPopup(true) or however you're displaying it
        return;
      }
    }
    setIsAddButtonDisabled(false);

    // 🔍 Check if this type already has confirmed classes
    const existingConfirmed = finalClassesSchedule.filter(event => event.ClassType === type);
    const hasConfirmedClasses = existingConfirmed.length > 0;

    // If already confirmed classes exist for this type, allow editing directly
    if (hasConfirmedClasses) {
      SchduleConfirmationClick(type); // brings confirmed classes into editable state
      return;
    }

    setActiveType(type);
    // Immediately report the “initial” selection for that card
    if (type === 'Driving') {
      SelectInstructorCallback(type, sortedCourseInstructors[inVehicleIndex]);
      setInstructorSelectedType("Driving")
    } else if (type === 'InClass') {
      SelectInstructorCallback(type, sortedCourseInstructors[inClassIndex]);
      setInstructorSelectedType("InClass")
    } else {
      SelectInstructorCallback(type, sortedCourseInstructors[onlineIndex]);
      setInstructorSelectedType("Online")
    }
  };

  // A helper that returns style props (background & border) for each card type
  const getCardStyles = (type) => {
    switch (type) {
      case 'Driving':
        return {
          buttonColor: '#0AA630',
          cardBg: '#FAFAFB',
          cardBorder: '#0AA630',
          cardBgActive: '#EBF8EE',
          leftSideBg: '#40C861',
          rightSideBg: '#0AA630'
        };
      case 'InClass':
        return {
          buttonColor: '#1F7BF4',
          cardBg: '#FAFAFB',
          cardBorder: '#1F7BF4',
          cardBgActive: '#FAFAFB',
          leftSideBg: '#68A9FE',
          rightSideBg: '#1F7BF4'
        };
      case 'Online':
        return {
          buttonColor: '#FC0000',
          cardBg: '#FAFAFB',
          cardBorder: '#FC0000',
          cardBgActive: '#FFEBEB',
          leftSideBg: '#FF8888',
          rightSideBg: '#FC0000'
        };
      default:
        return {
          buttonColor: '#CCCCCC',
          cardBg: '#FAFAFB',
          cardBorder: '#CCCCCC',
          cardBgActive: '#FFFFFF',
        };
    }
  };

  // const SchduleConfirmationClick = (type) => {
    
  //   setActiveType(type);

  //   // Immediately report the “initial” selection for that card
  //   if (type === 'Driving') {
  //     SelectInstructorCallback(type, instructors[inVehicleIndex]);
  //     setInstructorSelectedType("Driving")
  //   } else if (type === 'InClass') {
  //     SelectInstructorCallback(type, instructors[inClassIndex]);
  //     setInstructorSelectedType("InClass")
  //   } else {
  //     SelectInstructorCallback(type, instructors[onlineIndex]);
  //     setInstructorSelectedType("Online")
  //   }
  // };

  const SchduleConfirmationClick = (type, finalList = finalClassesSchedule) => {
    setActiveType(type);

    const filteredFinal = finalList.filter(event => event.ClassType !== type);
    const typeClasses = finalList.filter(event => event.ClassType === type);

    setFinalClassesSchedule(filteredFinal);
    setAddClassEvents(typeClasses);
  
    // Step 1: Filter out classes of the selected type from final schedule
    // const filteredFinal = finalClassesSchedule.filter(
    //   event => event.ClassType !== type
    // );
      console.log("filteredFinal in SchduleConfirmationClick:",filteredFinal)
    // Step 2: Extract classes of the selected type to re-edit
    // const typeClasses = finalClassesSchedule.filter(
    //   event => event.ClassType === type
    // );
    console.log("typeClasses in SchduleConfirmationClick:",typeClasses)

    // Step 3: Update state
    setFinalClassesSchedule(filteredFinal);       // Remove old ones
    console.log("finalClassesSchedule in SchduleConfirmationClick:",finalClassesSchedule)

    setAddClassEvents(typeClasses);               // Set them as editable/new
    console.log("addClassEvents in SchduleConfirmationClick:",addClassEvents)

    // Step 4: Handle instructor selection as before
    if (type === 'Driving') {
      SelectInstructorCallback(type, sortedCourseInstructors[inVehicleIndex]);
      setInstructorSelectedType("Driving");
    } else if (type === 'InClass') {
      SelectInstructorCallback(type, sortedCourseInstructors[inClassIndex]);
      setInstructorSelectedType("InClass");
    } else {
      SelectInstructorCallback(type, sortedCourseInstructors[onlineIndex]);
      setInstructorSelectedType("Online");
    }
  }; 
  
  const handleConfirm = (shouldDisableAddButton = false) => {
    console.log("addClassEvents in handleConfirm:",addClassEvents)

    const updatedFinal = [...finalClassesSchedule, ...addClassEvents];
    setFinalClassesSchedule(updatedFinal);

    // Append new class events to the existing final schedule
    // setFinalClassesSchedule(prev => [...prev, ...addClassEvents]);
    console.log("finalClassesSchedule in handleConfirm:",finalClassesSchedule)

      // Update based on activeType
      if (activeType === "Driving") {
        setFinalDrivingClassesSchedule(addClassEvents);
      } else if (activeType === "InClass") {
        setFinalInClassClassesSchedule(addClassEvents);
      } else if (activeType === "Online") {
        setFinalOnlineClassesSchedule(addClassEvents);
      } else {
        console.warn("Unknown activeType:", activeType);
      }      

    // Clear the temporary class events
    setAddClassEvents([]);

    // ✅ Conditionally disable the Add Schedule button
    // if (shouldDisableAddButton) {
    //   setIsAddButtonDisabled(true);
    //   setSelectedInstructorCardType(activeType)
    // }
  
    // Call confirmation handler and close popup
    SchduleConfirmationClick(selectedInstructorCardType, updatedFinal);
    setSelectedInstructorCardType(null)
    setShowScheduleConfirmationPopup(false);
  };
  
  useEffect(() => {
    // If there's no schedule data, use instructors as-is
    if (!allInstructorsScheduledClasses || allInstructorsScheduledClasses.length === 0) {
      console.log("No scheduled classes found — using default instructor list");
      setSortedCourseInstructors(instructors);
      return;
    }

    const now = new Date();
  
    // Step 1: Count future classes per instructor by UserId
    const futureClassCount = {};
    allInstructorsScheduledClasses.forEach((cls) => {
      const instructorId = cls.InstructorFK || cls.InstructorId;
      const start = new Date(cls.StartTime);
      if (start > now) {
        futureClassCount[instructorId] = (futureClassCount[instructorId] || 0) + 1;
      }
    });
    console.log("futureClassCount are:",futureClassCount)

    // Step 2: Sort instructors based on those counts
    const sorted = [...instructors].sort((a, b) => {
      const aId = a?.Instructor?.InstructorId;
      const bId = b?.Instructor?.InstructorId;
    
      const aCount = futureClassCount[aId] || 0;
      const bCount = futureClassCount[bId] || 0;
    
      return aCount - bCount;
    });
    
    console.log("sorted are:",sorted)
    setSortedCourseInstructors(sorted);
  }, [instructors, allInstructorsScheduledClasses]);

  // Render one “card” (for Driving, InClass, or Online)
  const renderInstructorCard = (type, label, hours, currentIndex) => {
    const isActive = activeType === type;
    const { buttonColor, cardBg, cardBorder, cardBgActive, leftSideBg, rightSideBg } = getCardStyles(type);
    const instructor = sortedCourseInstructors[currentIndex] || {};

    const getTotalScheduledHours = (scheduleArray) => {
      return scheduleArray.reduce((total, cls) => {
        const start = new Date(cls.StartTime);
        const end = new Date(cls.EndTime);
        const duration = (end - start) / (1000 * 60 * 60); // in hours
        return total + duration;
      }, 0);
    };
    
    // let completed = 0;
    // if (isSeparateSchedule) {
    //   if (type === 'Driving') {
    //     completed = getTotalScheduledHours(finalDrivingClassesSchedule);
    //   } else if (type === 'InClass') {
    //     completed = getTotalScheduledHours(finalInClassClassesSchedule);
    //   } else if (type === 'Online') {
    //     completed = getTotalScheduledHours(finalOnlineClassesSchedule);
    //   }
    // }

    // Get final schedule for this type
    const finalSchedule =
      type === 'Driving' ? finalDrivingClassesSchedule :
      type === 'InClass' ? finalInClassClassesSchedule :
      finalOnlineClassesSchedule;

    // Fallback to addClassEvents only if final schedule is empty
    const effectiveSchedule = finalSchedule.length > 0
      ? finalSchedule
      : addClassEvents.filter(e => e.ClassType === type);

    // const completed = getTotalScheduledHours(effectiveSchedule);
    const getEffectiveScheduledHoursForType = (type) => {
      // Get final classes for the type
      const finalSchedule =
        type === 'Driving' ? finalDrivingClassesSchedule :
        type === 'InClass' ? finalInClassClassesSchedule :
        finalOnlineClassesSchedule;
    
      // Filter addClassEvents by type
      const addClassTypeEvents = addClassEvents.filter(event => event.ClassType === type);
    
      // Get all final class IDs for this type
      const finalIds = new Set(finalSchedule.map(cls => cls.event_id));
    
      // Filter addClassEvents to only those NOT in final schedule
      const uniqueAddClassEvents = addClassTypeEvents.filter(cls => !finalIds.has(cls.event_id));
    
      // Merge unique + final
      const merged = [...finalSchedule, ...uniqueAddClassEvents];
    
      return getTotalScheduledHours(merged);
    };
    
    // Then use:
    const completed = getEffectiveScheduledHoursForType(type);
      
    // Conditionally render either "5/10" or just "10"
    // const displayHours = isSeparateSchedule ? `${completed}/${hours}` : hours;
    // const displayHours = `${completed}/${hours}` ;
    // const displayHours = `${completed.toFixed(2)}/${hours}`;
    const formatNumber = (num) => 
      num % 1 === 0 
        ? num.toString() 
        : num.toLocaleString(undefined, { maximumFractionDigits: 2 });

    const displayHours = `${formatNumber(completed)}/${formatNumber(hours)}`;


    const instructorLangs = (instructor?.Instructor?.InstructorLanguages || "").split(',').map(lang => lang.trim());

    const isExpanded = showAllLanguages[type] || false;

    const displayedLangs = isExpanded ? instructorLangs : instructorLangs.slice(0, 2);

    const toggleShowAllLanguages = () => {
      setShowAllLanguages(prev => ({
        ...prev,
        [type]: !prev[type]
      }));
    };


    return (
      <div className='flex flex-col w-[450px] 4xl:w-[31%]'>
        <div
          key={type}
          className={`flex justify-between h-[105px] cursor-pointer ${
            isActive ? 'text-[#FFFFFF]' : 'text-[#000000]'
          }`}
          style={{
            backgroundColor: isActive ? leftSideBg : cardBg,
            border: isActive ? '' : `1px solid ${cardBorder}`,
          }}
          onClick={() => handleActivate(type)}
        >
          {/* ── Instructor Info + Prev/Next (only clickable if active) ── */}
          <div className="w-full flex justify-between items-center px-[15px]"
          // style={{
          //   backgroundColor: isActive ? leftSideBg : cardBg,
          // }}
          >
            <div className='flex gap-[15px] items-center'>
                <div className="relative w-[66px] h-[66px]">
                    {/* Instructor Profile Image */}
                    <img
                      src={`${BaseUrl}/api/images/Instructors?url=${instructor.Instructor?.ProfileImage}`}
                      alt="Instructor"
                      className="w-[66px] h-[66px] rounded-[9px] object-cover"
                    />

                    {/* Gender Icon Overlay */}
                    {instructor.Instructor?.Gender === "Female" ? (
                      <img
                        src={require("../Assets/femaleIcon.svg").default}
                        alt="Female"
                        className="absolute top-[-10px] right-[-10px] w-[20px] h-[20px]"
                      />
                    ) : (
                      <img
                        src={require("../Assets/maleIcon.svg").default}
                        alt="Male"
                        className="absolute top-[-5px] right-[-10px] w-[20px] h-[20px]"
                      />
                    )}
                </div>
                <div className='flex flex-col gap-[5px]'>
                  <p className="text-[16px] font-semibold">
                    {instructor.FirstName} {instructor.LastName}
                  </p>
                  <p className="text-[16px] font-semilight break-words whitespace-normal">
                    {/* {instructor?.Instructor?.InstructorLanguages}  */}
                      {displayedLangs.join(', ')}
                      {instructorLangs.length > 2 && (
                        <div className="mt-[1px]">
                            <button
                              onClick={toggleShowAllLanguages}
                              className="w-[44px] h-[15px] rounded-[5px] text-[10px]  cursor-pointer"
                              style={{
                                backgroundColor: isActive ? '#FFFFFF' : '#AEB0FF',
                                color: isActive ? '#AEB0FF' : '#FFFFFF',
                              }}
                            >
                              {isExpanded ? "Hide All" : "Show All"}
                            </button>
                        </div>
                      )}
                  </p>
                </div>
            </div>
            {/* Prev Arrow */}
            <div className='flex gap-[10px] items-center'>
              <div
                // onClick={() => handlePrev(type)}
                onClick={(e) => {
                    e.stopPropagation(); // Prevents triggering handleActivate
                    handlePrev(type);
                  }}
                className={`w-[30px] h-[30px] rounded-full flex justify-center items-center ${
                  isActive ? 'cursor-pointer' : 'cursor-not-allowed'
                }`}
                // style={{ backgroundColor: buttonColor }}
                style={{
                  backgroundColor: isActive ? '#FFFFFF' : buttonColor,
                }}
              >
                <ArrowBackIcon sx={{ color: isActive ? rightSideBg : '#FFFFFF' }} />
              </div>

              {/* Next Arrow */}
              <div
                // onClick={() => handleNext(type)}
                onClick={(e) => {
                    e.stopPropagation(); // Prevents triggering handleActivate
                    handleNext(type);
                  }}
                className={`w-[30px] h-[30px] rounded-full flex justify-center items-center ${
                  isActive ? 'cursor-pointer' : 'cursor-not-allowed'
                }`}
                style={{
                  backgroundColor: isActive ? '#FFFFFF' : buttonColor,
                }}        
                >
                <ArrowForwardIcon sx={{ color: isActive ? rightSideBg : '#FFFFFF' }} />
              </div>
            </div>
          </div>

          {/* ── Label + Hours ── */}
          <div
            className="flex flex-col justify-center items-center p-[10px] gap-[10px] bg-no-repeat"
            // style={{
            //   backgroundColor: cardBgActive,
            //   // border: `1px solid ${cardBorder}`,
            // }}
            style={{
              backgroundColor: isActive ? rightSideBg : cardBgActive,
              border: `1px solid ${cardBorder}`,
            }}
          >
            <p className="text-[14px] font-poppinssans text-center w-[80px]">
              {label}
            </p>
            <p className="text-[16px] font-semibold">{displayHours}</p>
          </div>
        </div>

        {isActive && (
          <div className="flex gap-[10px] mt-[15px]">
            <button
              disabled={isAddButtonDisabled}
              onClick={() => {
                 if (isSeparateSchedule) {
                  setAddClassError("");
                  setShowWeeklyAddClassPopup(true);
                } else {
                  setAddClassError("");
                  setShowAddClassPopup(true);
                }
              }}
              type="button"
              // className="bg-[#AEB0FF] w-[106px] h-[40px] rounded-[4px] text-[14px] text-white focus:outline-none focus:ring-4"
              className={`w-[106px] h-[40px] rounded-[4px] text-[14px] text-white focus:outline-none focus:ring-4 ${
                isAddButtonDisabled ? 'bg-[#DCDEF6] cursor-not-allowed' : 'bg-[#AEB0FF] cursor-pointer'
              }`}
            >
              Add Schedule
            </button>

            <button
              disabled={addClassEvents.length === 0}
              onClick={() => {
                setShowDiscardSchedulePopup(true);
              }}
              type="button"
              className={`w-[120px] h-[40px] rounded-[4px] text-[14px] font-medium focus:outline-none focus:ring-4 ${
                addClassEvents.length > 0
                  ? 'bg-[#AEB0FF] text-white cursor-pointer'
                  : 'bg-[#DCDEF6] text-white cursor-not-allowed'
              }`}
            >
              Discard Schedule
            </button>

            <button
              onClick={() => {
                // setIsAddButtonDisabled(true); // Disable "Add Schedule" first
                handleConfirm();              // Then call the function
              }}
              disabled={addClassEvents.length === 0}
              type="button"
              className={`w-[120px] h-[40px] rounded-[4px] text-[14px] font-medium focus:outline-none focus:ring-4 ${
                addClassEvents.length > 0
                  ? 'bg-[#AEB0FF] text-white cursor-pointer'
                  : 'bg-[#DCDEF6] text-white cursor-not-allowed'
              }`}
            >
              Confirm Schedule
            </button>
          </div>

        )}
      </div>

    );
  };

  return (
    <div className=''>
        <p className='text-[16px] text-[#696974] font-semibold mt-[5px]'>Select a Class Type and Instructor:</p>
        <div className="flex flex-wrap justify-center 4xl:justify-between gap-[30px] w-full mt-[10px]">
          {DrivingHours > 0 && renderInstructorCard(
            'Driving',
            'In-Vehicle Classes',
            DrivingHours,
            inVehicleIndex
          )}
          {InClassHours > 0 && renderInstructorCard(
            'InClass',
            'In-Class Classes',
            InClassHours,
            inClassIndex
          )}
          {OnlineHours > 0 && renderInstructorCard(
            'Online',
            'Online Classes',
            OnlineHours,
            onlineIndex
          )}

          {showScheduleConfirmationPopup && (
            <ScheduleConfirmationPopup
            setShowScheduleConfirmationPopup={setShowScheduleConfirmationPopup}
            selectedInstructorCardType={selectedInstructorCardType}
            SchduleConfirmationClick={SchduleConfirmationClick}
            setFinalClassesSchedule={setFinalClassesSchedule}
            setAddClassEvents={setAddClassEvents}
            addClassEvents={addClassEvents}
            instructorSelectedType={instructorSelectedType}
            finalClassesSchedule={finalClassesSchedule}
            activeType={activeType}
            setFinalDrivingClassesSchedule={setFinalDrivingClassesSchedule}
            setFinalInClassClassesSchedule={setFinalInClassClassesSchedule}
            setFinalOnlineClassesSchedule={setFinalOnlineClassesSchedule}
            handleConfirm={handleConfirm}
            />
          )}
        </div>
    </div>
  );
};

export default InstructorCards;
